import { render, staticRenderFns } from "./AccessEdit.vue?vue&type=template&id=8dc97abe"
import script from "./AccessEdit.vue?vue&type=script&lang=js"
export * from "./AccessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports